import { apiPost, buildApiURL } from '@src/services/api';

const postTrackedDownload = (data) => {
    return apiPost(
        buildApiURL('/api/v1/tracked_downloads'),
        { tracked_download: data },
    );
};

export {
    postTrackedDownload,
};

